export type NotificationType = 'MESSAGE' | 'ALERT';

/** Tab order, left to right. The single source of truth for both surfaces. */
export const NOTIFICATION_TABS = [
    'MESSAGE',
    'ALERT',
] as const satisfies readonly NotificationType[];

export interface INotification {
    id: string;
    type: NotificationType;
    category: string;
    title: string;
    body: string;
    referenceType: string;
    referenceId: string | null;
    actionUrl: string | null;
    metadata: Record<string, unknown> | null;
    actorUserId: string | null;
    isRead: boolean;
    createdAt: string;
}

export interface IUnreadCounts {
    messageUnread: number;
    alertUnread: number;
}

export interface IListNotificationsResponse {
    items: INotification[];
    nextCursor: string | null;
}

export interface ISyncResponse {
    notifications: INotification[];
    counts: IUnreadCounts;
}

// ── WebSocket envelope + payloads (mirror the backend) ───────────────────
export interface IWsEnvelope<TPayload> {
    eventId: string;
    eventAt: string;
    name: string;
    payload: TPayload;
}

export interface IWsNewPayload {
    notification: INotification;
    actorUserId: string | null;
}

export const NOTIFICATION_WS_EVENTS = {
    NEW: 'notification:new',
    READ: 'notification:read',
    READ_MANY: 'notification:read_many',
    READ_ALL: 'notification:read_all',
} as const;

/**
 * The `referenceType` values this app reacts to beyond showing the row —
 * mirrors `REFERENCE_TYPES` in the API's `notifications/constants.ts`. Only the
 * ones with a client-side consequence are listed; the rest are display-only.
 */
export const NOTIFICATION_REFERENCE_TYPES = {
    BUG_REPORT: 'bug_report',
} as const;
